<template>
  <div>
    <el-drawer
      title="门店定位搜索"
      :visible.sync="selfVisible"
      :direction="direction"
      :before-close="handleClose"
      size="100%"
      @opened="handleOpen"
    >
      <div class="box-wrapper">
        <div class="search-box">
          <div>
            请输入：
            <el-input
              type="text"
              id="suggestId"
              name="address_detail"
              placeholder="地址"
              v-model="address_detail"
              class="search"
            ></el-input>
          </div>
          <el-button type="success" @click="handlerConfirm">保存</el-button>
        </div>
        <div id="map"></div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data() {
    return {
      selfVisible: false,
      direction: 'ttb',
      address_detail: null, // 详细地址
      userlocation: { lng: '', lat: '' },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selfVisible = newValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    createMap() {
      /* eslint-disable */
      // 创建Map实例
      const th = this;
      const map = new BMap.Map('map');
      // 初始化地图,设置中心点坐标和地图级别
      map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);
      map.enableScrollWheelZoom();

      const ac = new BMap.Autocomplete({
        //建立一个自动完成的对象
        input: 'suggestId',
        location: map,
      });

      let myValue;
      ac.addEventListener('onconfirm', function(e) {
        //鼠标点击下拉列表后的事件
        const _value = e.item.value;
        myValue =
          _value.province +
          _value.city +
          _value.district +
          _value.street +
          _value.business;
        th.address_detail = myValue;
        setPlace();
      });

      function setPlace() {
        map.clearOverlays(); //清除地图上所有覆盖物
        function myFun() {
          if (local.getResults().getPoi(0)) {
            th.userlocation = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
          }
          map.centerAndZoom(th.userlocation, 18);
          map.addOverlay(new BMap.Marker(th.userlocation)); //添加标注
        }

        var local = new BMap.LocalSearch(map, {
          //智能搜索
          onSearchComplete: myFun,
        });
        local.search(myValue);
      }
      /* eslint-enable */
    },
    handleOpen() {
      this.createMap();
    },
    handlerConfirm() {
      this.userlocation.addressdetail = this.address_detail;
      const { lng, lat, addressdetail } = this.userlocation;
      const [gglng, gglat] = this.bdTranslate(lng, lat);
      this.userlocation.lng = gglng;
      this.userlocation.lat = gglat;
      if (!gglng || !gglat || !addressdetail) {
        this.$message.warning('请输入门店地址获取位置信息');
      } else {
        this.$emit('confirm', this.userlocation);
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
          this.$emit('close');
        })
        .catch(() => {});
    },
    resetForm() {
      this.$refs.userlocation.resetFields();
      this.address_detail = null;
    },
    bdTranslate(bdlon, bdlat) {
      const xpi = (3.14159265358979324 * 3000.0) / 180.0;
      const x = bdlon - 0.0065;
      const y = bdlat - 0.006;
      const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xpi);
      const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xpi);
      const gglng = z * Math.cos(theta);
      const gglat = z * Math.sin(theta);
      return [gglng, gglat];
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
#map
  min-height 100vh
.box-wrapper
  position relative
  .search-box
    flex-row()
    justify-content space-between
    position relative
    padding 20px
    margin-bottom 15px
    .search
      width 300px !important
>>>.el-drawer__header
  margin-bottom 15px
</style>
<style lang="stylus">
.tangram-suggestion-main
  z-index 9999 !important
</style>
